var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteTickWithWhiteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7052 9.21685L10.5862 14.2127L8.29477 11.9765C7.9985 11.6873 7.51847 11.6873 7.2222 11.9765C6.92593 12.2656 6.92593 12.7341 7.2222 13.0232L10.0499 15.7828C10.1974 15.9268 10.3924 16 10.5862 16C10.7799 16 10.9737 15.928 11.1224 15.7828L16.7778 10.2636C17.0741 9.97447 17.0741 9.50599 16.7778 9.21685C16.4815 8.92772 16.0015 8.92772 15.7052 9.21685Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTickWithWhiteCircle);
export default __webpack_public_path__ + "static/media/whiteTickWithWhiteCircle.e9f4fdb2b754223a88d321df198b488f.svg";
export { ForwardRef as ReactComponent };